import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
	deleteCreditNote,
	fetchCreditNoteDetails,
} from '../../../../../services/sales_credit_note';
import { toast } from 'react-toastify';
import UseCreditNote from './useCreditNote';
import { useSelector } from 'react-redux';

const UseCreditNoteDetails = () => {
	const [creditNoteDetails, setCreditNoteDetails] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [isDeleteCNModalOpen, setIsDeleteCNModalOpen] = useState(false);
	const [isApplyInvoiceModalOpen, setIsApplyInvoiceModalOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const { handlePrintAndDownloadPdf } = UseCreditNote();
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');

	async function getCreditNoteDetails() {
		try {
			setLoading(true);
			var { credit_note } = await fetchCreditNoteDetails({ ids: [id] });
			if (credit_note) {
				setCreditNoteDetails(credit_note);
			}
		} catch (error) {
		} finally {
			setLoading(false);
		}
	}
	async function handleDeleteCreditNote() {
		try {
			var body = JSON.stringify({
				ids: [id],
			});
			await deleteCreditNote(body);
			toast.success('Credit Note deleted successfully');
			// navigate(`/user/${suburl}/sales/credit-note`);
			navigate(-1);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	}

	async function generateSalesCreditNotePdf(type = 'print', merge = false) {
		try {
			await handlePrintAndDownloadPdf(id, type, merge);
		} catch (error) {}
	}

	useEffect(() => {
		if (id) {
			getCreditNoteDetails();
		}
	}, [id]);

	return {
		user,
		creditNoteDetails,
		isDeleteCNModalOpen,
		setIsDeleteCNModalOpen,
		setIsApplyInvoiceModalOpen,
		isApplyInvoiceModalOpen,
		loading,
		navigate,
		id,
		suburl,
		generateSalesCreditNotePdf,
		handleDeleteCreditNote,
		getCreditNoteDetails,
	};
};
export default UseCreditNoteDetails;
